import * as yup from 'yup';

export const validationSchema = yup.object({
  title: yup.string(),
  tagline: yup.string(),
  description: yup.object(),
});
